let ws;

export function connectWebSocket({commit, dispatch}) {
    const wsUrl = process.env.VUE_APP_WS_URL || 'ws://localhost:8765';
    ws = new WebSocket(wsUrl);
  
    ws.onopen = () => {
      console.log('WebSocket connection established');
      commit('updateSocket', { status: 'open', ws });
      ws.send(JSON.stringify({ type: 'getStateData' }));
    };
  
    ws.onmessage = (event) => {
      const receivedData = JSON.parse(event.data);
      dispatch('processReceivedData', receivedData);
    };
  
    ws.onclose = () => {
      commit('updateSocket', { status: 'closed', ws: null });
      console.warn('WebSocket connection closed');
    };
  
    ws.onerror = (error) => {
      console.error('WebSocket error:', error);
    };
  
    return ws;
  }

  export function sendForm(formLabel, order) {
    if (ws && ws.readyState === WebSocket.OPEN) {
      ws.send(JSON.stringify({ type: formLabel, order }));
    } else {
      console.error('WebSocket is not open. Cannot send order.');
    }
  }
  